module.exports = __webpack_public_path__ + "img/Group.7afe4563.svg";